export interface CookieData {
	favorites?: string;
	preferences?: string;
	'nuxt-session'?: string;
}

/**
 * Composable helper para coletar dados dos cookies
 * para uso com nuxtPropertiesRepository
 */
export function useCookieData(): () => CookieData {
	const { cookie: favoritesCookie } = useFavoritesCookie();
	const { getPreferences } = usePreferencesCookie();
	const sessionCookie = useCookie<string>('nuxt-session');

	return () => {
		const cookieData: CookieData = {};

		if (favoritesCookie.value) {
			cookieData.favorites = favoritesCookie.value;
		}

		const preferences = getPreferences();
		if (preferences && Object.keys(preferences).length > 0) {
			cookieData.preferences = JSON.stringify(preferences);
		}

		if (sessionCookie.value) {
			cookieData['nuxt-session'] = sessionCookie.value;
		}

		return cookieData;
	};
}
